import { type ComboboxItem } from "@mantine/core";
import type { DateTimeFormatOptions } from "luxon";
import { DateTime } from "luxon";

export const DATE_FOR_TESTS = DateTime.fromISO("2025-03-14T15:09:26.535Z");
export const THIS_YEAR = new Date().getUTCFullYear();
export const LAST_YEAR = THIS_YEAR - 1;
export const NEXT_YEAR = THIS_YEAR + 1;

export const LOCAL_DATE_SETTINGS: DateTimeFormatOptions = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
};

export const DATE_TIME_DISPLAY_WITHOUT_SECONDS_SETTINGS: DateTimeFormatOptions =
  {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit"
  };

export const LUXON_START_OF_LAST_YEAR = DateTime.now()
  .minus({ years: 1 })
  .startOf("year");
export const LUXON_END_OF_LAST_YEAR = DateTime.now()
  .minus({ years: 1 })
  .endOf("year");

export const LUXON_START_OF_LAST_MONTH = DateTime.now()
  .minus({ months: 1 })
  .startOf("month");
export const LUXON_END_OF_LAST_MONTH = DateTime.now()
  .minus({ months: 1 })
  .endOf("month");

const TODO_YEAR_CHANGE_DATE = new Date(THIS_YEAR, 0, 2);
const shouldShowThisYearForTodos = TODO_YEAR_CHANGE_DATE < new Date();
export const INITIAL_TODO_YEAR = shouldShowThisYearForTodos
  ? THIS_YEAR
  : LAST_YEAR;
export const FINAL_TODO_YEAR = INITIAL_TODO_YEAR;

const MONTHS = [
  "Januar",
  "Februar",
  "März",
  "April",
  "Mai",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "Dezember"
];

export const MONTH_CHOICES: Array<ComboboxItem> = MONTHS.map(
  (month, index) => ({
    value: (index + 1).toString(),
    label: month
  })
);
